import $ from "jquery";
import Util from './utils';

var tabModal = $('#fyh-tab-modal');

if ( tabModal.length > 0 ) {
    /** On modal open For Your Home **/
    tabModal.on('open.zf.reveal', function () {

        /** This is used to absolute position the "View all" button within the tabs but out of markup **/
        var divHeight = $('#fyh-tab-modal-tabs').innerHeight();
        $('.fyh-tab-modal_view-all-tabs').css('top', divHeight - 100);
        
        // When tab is navigated with arrow key, focus is lost to parent container, this brings proper focus to close button on shift tab 
        $('#fyh-tab-modal-tabs a').keydown(function (e) {
            if (e.which == 9) {
                if(e.shiftKey) {
                    e.preventDefault();
                    $('#fyh-tab-modal button').focus();
                    }
            }
        });
    
        // Get url paramaters and check if there is a state so we can set the active state of the modal
        var state = Util.getUrlParameters()["state"];
        if (state != null && state != undefined && state != "" && state != "any") {
            state = decodeURI(state);
            $('#fyh-tab-modal-tabs a').each(function () {
                if (state == this.text) {
                
                    $('#fyh-tab-modal-tabs').foundation('selectTab', this.id.replace("-label",""));
                }
            });
        }
        else {
            /** This resets the tab state to the first tap on open **/
            $('#fyh-tab-modal-tabs').foundation('selectTab', 'tab-0');
        }

        /** Set the index of the modal to 0 to set focus **/
        tabModal.attr('tabindex', 0);
    });

    /** Closing modal on breakpoint **/
    $(window).on('changed.zf.mediaquery', function (event, newSize, oldSize) {
        if (newSize == "small" && oldSize == "medium") {
            tabModal.foundation('close');
        }

        /** This is used to absolute position the "View all" button within the tabs but out of markup **/
        var divHeight = $('#fyh-tab-modal-tabs').innerHeight();
        $('.fyh-tab-modal_view-all-tabs').css('top', divHeight - 100);

    });
}




